import { useTranslate } from '@growtherapy/i18n';
import { Body } from '@growtherapy/sprout-ui';

import { longDateTimeWithTimezoneFormatter } from '@grow-therapy-team/seedling-components';

export function IntersessionSummaryDisclaimer({ createdAt }: { createdAt: string }): JSX.Element {
  const t = useTranslate();

  return (
    <Body.Small className='rebrand:text-text-muted'>
      {t('telehealth-core:providerIntersessionSummary.summaryDisclaimer', {
        timestamp: longDateTimeWithTimezoneFormatter.format(new Date(createdAt)),
      })}
    </Body.Small>
  );
}
